import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';

import Homepage from './components/Homepage';
import MapController from './components/MapController';
import { store }  from './store/store';

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'leaflet/dist/leaflet.css';


Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

Vue.config.productionTip = false; 

const routes = [
  { path: '/', component: Homepage },
  { path: '/map', component: MapController},
];

const router = new VueRouter({ routes }); 

export const serviceBus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
